import type { Point2d } from "."

export const findDistanceBetweenPoints = (p1: Point2d, p2: Point2d): number => {
  const dx = p2.x - p1.x
  const dy = p2.y - p1.y

  return Math.sqrt(dx * dx + dy * dy)
}
